import React from 'react';
import styled, { css } from 'styled-components';

interface CardDetailsItemMobileProps {
    itemLabel: string;
    itemValue: string;
}

export const CardDetailsItem = ({ itemLabel, itemValue }: CardDetailsItemMobileProps) => {
    return (
        <Container>
            <ItemValue>
                {itemLabel}
            </ItemValue>
            <ItemLabel>
                {itemValue}
            </ItemLabel>
        </Container>
    );
};

const Container = styled.li`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 25%;
`;

const CommonItemStyles = css`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-weight: 400;
`;

const ItemValue = styled.div`
    ${CommonItemStyles}
    font-size: 15px;
    color: #666;
`;

const ItemLabel = styled.div`
    ${CommonItemStyles}
    font-size: 13px;
    color: #aaa;
`;